export default "__VITE_ASSET__CKqLwyp___"